import gql from 'graphql-tag';

export const recentlyViewedIntegrationFragment = gql`
  fragment recentlyViewedIntegrationFragment on RecentlyViewedIntegration {
    dokkioClass
    integrationID
    lastViewedAt
  }
`;
export default recentlyViewedIntegrationFragment;
